import React from 'react';
import { Alert, AlertContext, Form } from '../../components';
import BaseUpload from './base-upload.component';
import BaseValidate from './base-validate.component';
import ApiService from '../../services/api.service';

interface IProps { 
    history?: any;
    id?: number;
    caption?: string;
    captionColor?: any;
    buttonCaption?: string;
    successCaption?: string;
    endPointFilter?: string;
    model: any;
    datarow: any;
    datarowMedia?: any;
    validations?: any;
    onLoad?: (data: any) => void;
    onError?: (data: any) => void;
    onSaveBefore?: () => void;
    onSave?: (data: any) => void;
    save?: boolean;
    buttonOnBottom?: boolean;
    cardColor?: any;
    cardGradientColor?: any;
    disableAutoBack?: boolean;
    disableBackButton?: boolean;
    disableCard?: boolean;
    children?: React.ReactNode;
}

interface IState {
    endPointFilter: string;
}

export default class BaseEdit extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            endPointFilter: props.endPointFilter || '',
        }
    }

    static contextType = AlertContext;
    private isLoading: boolean = false;
    private isSaving: boolean = false;
    private id = () => this.props.id?.toString() || this.props.history?.location.state?.id || '';

    private success = () => {
        if (!this.props.successCaption || this.props.successCaption !== ' ') 
            Alert(this.context, this.props.successCaption || 'Data edited.', 'success');   
        if (!this.props.disableAutoBack) 
            this.props.history?.goBack();        
        this.isSaving = false;
    }

    private onSave = async() => {
        this.isSaving = true;
        await this.props.onSaveBefore?.();
        
        var errors = BaseValidate.validate(this.props.datarow, this.props.validations || this.props.model.validations);
        this.props.onError?.(errors);
           
        if (!errors) 
        await ApiService.update<typeof this.props.model>(this.props.model.endPoint + '/', this.id(), this.props.model.endPointAuth? this.props.datarow : {data: this.props.datarow})
        .then(rp =>  {
            if (rp.Status) {
                if (rp.Data) var data = new this.props.model(rp.Data);
                if (this.props.datarowMedia && data)
                    BaseUpload.uploadFile(data.id, this.props.datarowMedia)
                    .then(rp1 => {
                        data = new this.props.model({...data, ...rp1});
                        Alert(this.context, rp1.alert, rp1.alertType);
                        this.props.onSave?.(data);
                        this.success();
                    });
                else {
                    this.props.onSave?.(data);
                    this.success();
                }
            }
            else { 
                if (this.props.onError && rp.Errors) 
                    this.props.onError(rp.Errors) 
                else
                    Alert(this.context, rp.Messages, 'error'); 
                this.isSaving = false;
            }            
        });
    }

    public componentDidMount() {
        if (this.isLoading) return;
        this.isLoading = true;
        
        ApiService.get<typeof this.props.model>(this.props.model.endPoint + (this.props.endPointFilter || '?populate=*&filters[id]='), this.id())
        .then(rp => {
            if (rp.Status) {              
                const data = rp.Data.length === 0? this.props.model.defaultValue() : new this.props.model(rp.Data[0]); 
                this.props.onLoad?.(data);
            } 
            else Alert(this.context, rp.Messages, 'error');
            this.isLoading = false;
        });
    }
    
    public componentDidUpdate() {
        if (!this.isLoading)
            if (this.props.endPointFilter && this.state.endPointFilter !== this.props.endPointFilter) {
                this.setState({endPointFilter: this.props.endPointFilter})
                this.componentDidMount();
            }
        if (this.props.save && !this.isSaving) this.onSave();
    }


    render() {
        return(
            <Form history={this.props.history} caption={this.props.caption || 'Edit ' + this.props.model.caption} captionColor={this.props.captionColor} buttonCaption={this.props.buttonCaption || 'save'} buttonOnBottom={this.props.buttonOnBottom} onSubmit={this.onSave} cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>              
                {this.props.children}
            </Form>
        );
    }
}